import {
  GetWorkSpacesDocument,
  GetWorkSpacesQuery,
  GetWorkSpacesQueryVariables,
  WorkSpaceFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type WorkSpaceNode = WorkSpaceFragment
export type WorkSpaceNodes = GetWorkSpacesQuery['spaceControl']['workSpacesConnection']['nodes']

export const useWorkSpaces = (variables: GetWorkSpacesQueryVariables) => {
  const { loading, data } = useQuery(GetWorkSpacesDocument, { variables })

  return {
    loading,
    workSpaces: data ? data.spaceControl.workSpacesConnection.nodes : [],
  }
}
